module.exports = __webpack_public_path__ + "static/media/rotary_international_2.ec6d295f.jpg";